import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useAllOptions from 'data-hooks/useAllOptions';
import useFabricReviews from 'data-hooks/useFabricReviews';
import usePDPFabricFilters from 'data-hooks/usePDPFabricFilters';
import useIsBrowser from 'hooks/useIsBrowser';
import PDPShownInUI from './PDPShownInUI';
import usePDPOptions from '../state/context/usePDPOptions';
const PDPShownInInner = t0 => {
  const $ = _c(25);
  const {
    fullWidth: t1,
    onSelection,
    optionId,
    upholsteryName,
    valueId,
    productName: t2,
    layout,
    showInactiveUpholstery: t3
  } = t0;
  const fullWidth = t1 === undefined ? false : t1;
  const productName = t2 === undefined ? null : t2;
  const showInactiveUpholstery = t3 === undefined ? false : t3;
  const [showInactiveTooltip, setShowInactiveTooltip] = useState(false);
  const {
    actions: t4
  } = usePDPOptions();
  const {
    onOptionValueSelection
  } = t4;
  const {
    data: t5
  } = useFabricReviews(valueId);
  const {
    reviews,
    rating
  } = t5;
  const {
    data: t6
  } = usePDPFabricFilters(null, false);
  const {
    allMaterials
  } = t6;
  const {
    allOptionsValues,
    allOptionsByValuesKey
  } = useAllOptions();
  let t7;
  bb0: {
    if (!allOptionsValues) {
      t7 = null;
      break bb0;
    }
    if (!valueId && upholsteryName && allOptionsByValuesKey && showInactiveUpholstery) {
      const valueKey = upholsteryName.toLowerCase().trim().split(" ").join("-");
      t7 = allOptionsByValuesKey[valueKey];
      break bb0;
    }
    t7 = allOptionsValues[valueId];
  }
  const materialDetails = t7;
  let t8;
  let t9;
  if ($[0] !== allMaterials || $[1] !== showInactiveTooltip || $[2] !== showInactiveUpholstery || $[3] !== valueId) {
    t8 = () => {
      if (!allMaterials || !showInactiveUpholstery) {
        return;
      }
      const value = valueId ? allMaterials.find(t10 => {
        const {
          materialId
        } = t10;
        return materialId === valueId;
      }) : null;
      if (value && showInactiveTooltip) {
        setShowInactiveTooltip(false);
      }
    };
    t9 = [valueId, allMaterials, showInactiveTooltip, showInactiveUpholstery];
    $[0] = allMaterials;
    $[1] = showInactiveTooltip;
    $[2] = showInactiveUpholstery;
    $[3] = valueId;
    $[4] = t8;
    $[5] = t9;
  } else {
    t8 = $[4];
    t9 = $[5];
  }
  useEffect(t8, t9);
  if (!optionId || !showInactiveUpholstery && !valueId || !upholsteryName) {
    return null;
  }
  let t10;
  if ($[6] !== allMaterials || $[7] !== onOptionValueSelection || $[8] !== onSelection || $[9] !== optionId || $[10] !== showInactiveUpholstery || $[11] !== valueId) {
    t10 = () => {
      const value_0 = valueId ? allMaterials.find(t11 => {
        const {
          materialId: materialId_0
        } = t11;
        return materialId_0 === valueId;
      }) : null;
      if (showInactiveUpholstery && !value_0) {
        setShowInactiveTooltip(true);
        return;
      }
      onOptionValueSelection(optionId, valueId);
      if (typeof onSelection === "function") {
        onSelection();
      }
    };
    $[6] = allMaterials;
    $[7] = onOptionValueSelection;
    $[8] = onSelection;
    $[9] = optionId;
    $[10] = showInactiveUpholstery;
    $[11] = valueId;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== fullWidth || $[14] !== layout || $[15] !== materialDetails || $[16] !== optionId || $[17] !== productName || $[18] !== rating || $[19] !== reviews || $[20] !== showInactiveTooltip || $[21] !== showInactiveUpholstery || $[22] !== t10 || $[23] !== upholsteryName) {
    t11 = <PDPShownInUI upholsteryOptionTypeId={optionId} materialDetails={materialDetails} displayedUpholsteryLabel={upholsteryName} fullWidth={fullWidth} reviews={reviews} rating={rating} setUpholstery={t10} productName={productName} layout={layout} showInactiveTooltip={showInactiveTooltip} showInactiveUpholstery={showInactiveUpholstery} />;
    $[13] = fullWidth;
    $[14] = layout;
    $[15] = materialDetails;
    $[16] = optionId;
    $[17] = productName;
    $[18] = rating;
    $[19] = reviews;
    $[20] = showInactiveTooltip;
    $[21] = showInactiveUpholstery;
    $[22] = t10;
    $[23] = upholsteryName;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
};
PDPShownInInner.propTypes = {
  fullWidth: PropTypes.bool,
  layout: PropTypes.string,
  onSelection: PropTypes.func,
  optionId: PropTypes.number,
  productName: PropTypes.string,
  showInactiveUpholstery: PropTypes.bool,
  upholsteryName: PropTypes.string,
  valueId: PropTypes.number
};
const PDPShownIn = props => {
  const $ = _c(2);
  const isBrowser = useIsBrowser();
  if (isBrowser) {
    let t0;
    if ($[0] !== props) {
      t0 = <PDPShownInInner {...props} />;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  return null;
};
export default PDPShownIn;